import { createStrategyManager, type DynamicComponent } from '@dec/shared';

import currencyStrategyAdapter from './strategies/CurrencyStrategyAdapter';
import dateStrategyAdapter from './strategies/DateStrategyAdapter';
import listStrategyAdapter from './strategies/ListStrategyAdapter';
import numberStrategyAdapter from './strategies/NumberStrategyAdapter';
import { createSectionStrategyAdapter } from './strategies/SectionStrategyAdapter';
import textStrategyAdapter from './strategies/TextStrategyAdapter';

import './strategies/styles.scss';

const strategies = [] as Array<DynamicComponent>;
const strategyManager = createStrategyManager(strategies);

const sectionStrategyAdapter = createSectionStrategyAdapter(strategyManager.CreateComponent);

strategies.push(
  textStrategyAdapter,
  numberStrategyAdapter,
  sectionStrategyAdapter,
  dateStrategyAdapter,
  currencyStrategyAdapter,
  listStrategyAdapter
);

export { strategyManager };
